import { defineStore } from 'pinia'
import type { User } from '~/types'
import { USER_ROLES } from '~/constants/auth'

export const useAuthStore = defineStore(
  'auth',
  () => {
    const token = ref<string | null>(null)
    const user = ref<User | null>(null)
    const agent = ref<User | null>(null)
    const isLoadingAgent = ref(false)
    const countryCode = ref<string | null>(null)
    const isAutoLoading = ref(false)

    const login = (newToken: string, newUser: User) => {
      token.value = newToken
      user.value = newUser
    }

    const logout = () => {
      token.value = null
      user.value = null
      agent.value = null
    }

    const updateUser = (newUser: User) => {
      user.value = { ...user.value, ...newUser }
    }

    const setCountryCode = (code: string) => {
      countryCode.value = code
    }

    const updateAgent = (newAgent: User) => {
      agent.value = newAgent
    }

    const updateAgentLoading = (loading: boolean) => {
      isLoadingAgent.value = loading
    }

    const updateAutoLoading = (loading: boolean) => {
      isAutoLoading.value = loading
    }

    const getIsLoadingAgent = computed(() => isLoadingAgent.value)
    const getIsAutoLoading = computed(() => isAutoLoading.value)
    const getIsAdmin = computed(() => user.value?.role === USER_ROLES.ADMIN)
    const getToken = computed(() => token.value)
    const getUser = computed(() => user.value)
    const getAgent = computed(() => agent.value)
    const getCountryCode = computed(() => countryCode.value)

    return {
      token,
      user,
      agent,
      isLoadingAgent,
      countryCode,
      isAutoLoading,
      login,
      logout,
      updateUser,
      updateAgent,
      updateAgentLoading,
      setCountryCode,
      updateAutoLoading,
      getIsLoadingAgent,
      getIsAdmin,
      getToken,
      getUser,
      getAgent,
      getCountryCode,
      getIsAutoLoading,
    }
  },
  {
    persist: {
      storage: persistedState.localStorage,
      pick: ['token', 'user'],
    },
  }
)
